import { createSlice } from '@reduxjs/toolkit';

const initialState = {};

const haveEntriesForFirm = (aMappingObj, firmId) => aMappingObj.hasOwnProperty(firmId);

export const orgTasksSlice = createSlice({
  name: 'orgTasks',
  initialState: initialState,
  reducers: {
    clearOrgTasks: () => {
      return initialState;
    },

    setOrgTasksForFirm: (state, action) => {
      const { visibleFirmId, tasks } = action.payload;
      return { ...state, [visibleFirmId]: tasks };
    },

    addOrgTaskForFirm: (state, action) => {
      const { visibleFirmId, task } = action.payload;
      if (haveEntriesForFirm(state, visibleFirmId)) {
        const prevTasksForFirm = state[visibleFirmId];
        return { ...state, [visibleFirmId]: [...prevTasksForFirm, task] };
      } else {
        return { ...state, [visibleFirmId]: [task] };
      }
    },
  },
});

export const { clearOrgTasks, setOrgTasksForFirm, addOrgTaskForFirm } = orgTasksSlice.actions;

export default orgTasksSlice.reducer;
